import { EMPTY_STRING } from '@/data/constants/marketing';
import { useCookies } from 'react-cookie';
import {
	DEFAULT_DELIVERY_LOCALITY,
	DEFAULT_DELIVERY_STATE,
	DEFAULT_DELIVERY_ZIPCODE,
	DELIVERY_LOCATION_COOKIE_NAME,
} from 'shared/custom/constants/commonConstants';

export const useDeliveryLocationCookie = () => {
	const [cookies] = useCookies([DELIVERY_LOCATION_COOKIE_NAME]);
	const deliveryLocationCookie = cookies?.[DELIVERY_LOCATION_COOKIE_NAME];

	const addressId = deliveryLocationCookie?.addressId ?? EMPTY_STRING;
	const locality = deliveryLocationCookie?.locality ?? DEFAULT_DELIVERY_LOCALITY;
	const state = deliveryLocationCookie?.state ?? DEFAULT_DELIVERY_STATE;
	const zipCode = deliveryLocationCookie?.zipCode ?? DEFAULT_DELIVERY_ZIPCODE;

	return {
		addressId,
		locality,
		state,
		zipCode,
	};
};
